import { Component, inject, OnInit, signal } from "@angular/core";
import { AppMonitoringService } from "../../AppMonitoringService";
import { AppInfoService } from "../../singletons/app-info.service";
import { CtrlClickDirective } from "../../directives/ctrl-click.directive";

@Component({
  selector: 'corteva-footer',
  templateUrl: 'footer.component.html',
  styleUrl: 'footer.component.less',
  standalone: true,
  imports: [CtrlClickDirective]
})
export class AppFooterComponent implements OnInit {
  private service = inject(AppInfoService);
  private appMonitoringService = inject(AppMonitoringService);

  protected Version = signal('');
  protected ShowTechInfo = signal(false);
  protected AppInsightsUrl = signal('');
  protected readonly Copyright = 'TM ,®, SM Trademarks of DuPont, Dow AgroSciences or Pioneer, and their affiliated companies or their respective owners. © ' + new Date().getFullYear() + ' Corteva';

  ngOnInit() {
    this.service.getAppStartupInfo().subscribe((info) => {
      this.Version.set(info.BuildVersion);
    });
    this.appMonitoringService.GetEnvironmentSpecificAppInsightsConfig().subscribe((c) => {
      this.AppInsightsUrl.set(c.Url);
    });
  }

  protected toggleTechInfo() {
    this.ShowTechInfo.set(!this.ShowTechInfo());
  }
}
